export const OrderType: { [id: number]: { label: string, icon: string } } = {
  1: {
    label: 'E-post/Telefon',
    icon: 'fa-solid fa-file-invoice'
  },
  10: {
    label: 'Webshop',
    icon: 'fa-solid fa-cart-shopping'
  },
  15: {
    label: 'Scannerorder',
    icon: 'fa-solid fa-barcode'
  },
  16: {
    label: 'Scannerorder',
    icon: 'fa-solid fa-barcode'
  },
  20: {
    label: 'EDI',
    icon: 'fa-solid fa-arrow-progress'
  },
  21: {
    label: 'EDI',
    icon: 'fa-solid fa-arrow-progress'
  },
  19: {
    label: 'Punchout',
    icon: 'fa-solid fa-cart-arrow-down'
  },
}
